var youkuVideoEmbed = youkuVideoEmbed || {};
var YT = YT || {};
var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.videoBlockFormatterV2 = {
    attach: function (context) {
      var self = this;
      var $videoCarousel = $('.video-block-media__carousel', context);
      var $slides = $('.video-block__media', context);
      var $mediaBlocks = $('.video-block__media', context);

      if ($slides.length > 1) {
        $videoCarousel.slick({
          rtl: site.direction.isRTL,
          infinite: true,
          arrows: $videoCarousel.data('arrows'),
          dots: $videoCarousel.data('dots'),
          appendDots: $('.video-block__slick-dots'),
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<span class="video-block__carousel-button video-block__carousel-prev icon icon-arrow_left"></span>',
          nextArrow: '<span class="video-block__carousel-button video-block__carousel-next icon icon-arrow_right"></span>'
        });
      }

      // init videos
      $mediaBlocks.each(function () {
        var $thisMediaBlock = $(this);
        var $videoPlayer = $thisMediaBlock.find('.video-block__player');
        var $videoWrapper = $thisMediaBlock.find('.video-block__video');
        var $video = $thisMediaBlock.find('video');

        // init Youku
        if ($thisMediaBlock.data('video-provider') === 'youku') {
          $videoWrapper.append(youkuVideoEmbed.addYoukuVideo($thisMediaBlock.data('youku-id'), $video.attr('id')));
          $video.remove();
        }
        $videoPlayer.once().on('click', function () {
          if ($thisMediaBlock.data('video-provider') === 'youtube') {
            self.initYouTube($thisMediaBlock.data('youtube-id'), context);
          }
        });
      });
    },
    initYouTube: function (youtubeID) {
      var player = new YT.Player('player-' + youtubeID, {
        height: '500',
        width: '900',
        videoId: youtubeID,
        events: {
          onReady: function (event) {
            // Don't autoplay on mobile
            if (!Modernizr.touch) {
              event.target.playVideo();
            }
          }
        }
      });
    }
  };
})(jQuery);
